import {Injectable} from '@angular/core';
import {FnInputModel} from '../../../core/model/fn-input.model';

/**
 * MetaDataSevice used to set and get field Object to create and validate Form Field.
 */
@Injectable()
export class FnUiFieldMetaDataService {

    /**
     * Ui field map 
     * used to store Fields object.
     */
    uiFieldMap: object|any;

    /**
     * Gets field for id 
     * used to get field object by Field key
     * @param uiFieldKey 
     * @returns  
     */
    getFieldForId(uiFieldKey: string) {
        return this.uiFieldMap[uiFieldKey];
    }

    /**
     * Sets field for id
     * used to set field object by Field Key
     * @param uiFieldKey 
     * @param uiFieldVal 
     */
    setFieldForId(uiFieldKey: string, uiFieldVal: FnInputModel) {
        this.uiFieldMap[uiFieldKey] = uiFieldVal;
    }

    /**
     * Sets field map
     * used to asssing object with mulitple field
     * @param uiFieldMap 
     */
    setFieldMap(uiFieldMap: object) {
        this.uiFieldMap = uiFieldMap;
    }

    /**
     * Gets field map
     * used to get uiFieldMap
     * @returns  
     */
    getFieldMap() {
        return this.uiFieldMap;
    }
}
